import { useSearchParams } from "react-router-dom";

// Keeps the active tab in ?tab= and pushes a history entry, so the browser Back button returns to the previous tab.
export function useTabParam(fallback, allowed) {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const tab = raw && (!allowed || allowed.includes(raw)) ? raw : fallback;
  const setTab = (v) => {
    // Radix fires onValueChange on mousedown and focus; compare with the live URL so one click = one history entry.
    const current = new URLSearchParams(window.location.search).get("tab") || fallback;
    if (v === current) return;
    const next = new URLSearchParams(params);
    if (v === fallback) next.delete("tab"); else next.set("tab", v);
    setParams(next);
  };
  return [tab, setTab];
}
